export function getScript(url) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject('getScript need url');
      return;
    }
    const script = document.createElement('script');
    script.onerror = reject;
    script.onload = resolve;
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    document.body.appendChild(script);
  });
}

export function isiOS() {
  const e = navigator.userAgent;
  return /iphone|ipod|ipad|Mac OS X/i.test(e) || !!e.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

export const getStorageData = (key) => {
  const originData = window.localStorage.getItem(key);
  if (!originData) return;
  try {
    const parseOriginData = JSON.parse(originData);
    if (parseOriginData.expiredTime && parseOriginData.expiredTime < Date.now()) {
      return null;
    }
    return parseOriginData.value;
  } catch (e) {
    return null;
  }
};

export const setStorageData = (key, value, options) => {
  const params = {
    value,
    expiredTime: 0,
    ...options,
  };

  window.localStorage.setItem(key, JSON.stringify(params));
};
